import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'IntegerFormatPipe'
})
export class IntegerFormatPipe implements PipeTransform {
  transform(value: any, separator: string = ' '): string {
  if (isNaN(value)) return '0';
  
  return Math.trunc(Number(value))
    .toString()
    .replace(/\d(?=(\d{3})+$)/g, `$&${separator}`);
}

}